import { render } from "./kanban01.vue?vue&type=template&id=79c6ee44&scoped=true"
import script from "./kanban01.vue?vue&type=script&lang=js"
export * from "./kanban01.vue?vue&type=script&lang=js"

import "./kanban01.vue?vue&type=style&index=0&id=79c6ee44&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6ee44"]])

export default __exports__